
import {Component} from 'vue-property-decorator';
import FaBoxComponent from '@/Components/FaBoxComponent.vue';

@Component({})
class FaRadioComponent extends FaBoxComponent {
    static COMPONENT_NAME = 'fa-radio-component';

    box: string = 'circle';
}

export default FaRadioComponent;
